import { PropsWithChildren } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

export function OverlayDialog({
  onClose,
  isClosable = true,
  panelClassName,
  children,
}: PropsWithChildren<{
  onClose: () => void;
  isClosable?: boolean;
  panelClassName?: string;
}>) {
  return (
    <Dialog
      open
      onClose={() => {
        if (isClosable) onClose();
      }}
      className="relative z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className={panelClassName}>{children}</DialogPanel>
      </div>
    </Dialog>
  );
}
